import { ReactNode } from 'react'

import classNames from 'classnames'

import './ScrollablePanel.scss'

interface ScrollablePanelProps {
  header?: ReactNode
  className?: string
  bodyClassName?: string
  children?: ReactNode
}

export const ScrollablePanel: React.FC<ScrollablePanelProps> = ({
  header,
  className,
  bodyClassName,
  children,
}) => {
  return (
    <div className={classNames('scrollable-panel', className)}>
      {header && <div className="scrollable-panel__header">{header}</div>}
      <div className={classNames('scrollable-panel__body', bodyClassName)}>
        {children}
      </div>
    </div>
  )
}
